import { render, staticRenderFns } from "./PatternRecognition.vue?vue&type=template&id=6190e7ea&"
import script from "./PatternRecognition.vue?vue&type=script&lang=js&"
export * from "./PatternRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports